var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEsgProfiler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 180,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 284,
    height: 190,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h244a8 8 0 0 1 8 8v158H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h244a7.5 7.5 0 0 1 7.5 7.5v157.5h-259V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1221"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h244a8 8 0 0 1 8 8v16H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h244a7.5 7.5 0 0 1 7.5 7.5v15.5h-259V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(22 23.21)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(0 -.21)",
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8 -.21)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16 -.21)",
    fill: "#00c243"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1225"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 37h222v143H31z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M31.5 37.5h221v142h-221z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1224",
    transform: "translate(-300 -2192)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1222",
    transform: "translate(-131.365 1283)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 13",
    width: 121,
    height: 16,
    rx: 3,
    transform: "translate(513.365 1060)",
    fill: "#fd0826"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "Explore sustainable investing",
    transform: "translate(517.365 1071)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Explore sustainable investing"))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Your ESG Profile",
    transform: "translate(408 2256)",
    fill: "#454545",
    fontSize: 9,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700,
    opacity: 0.994
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Your ESG Profile")), /*#__PURE__*/React.createElement("text", {
    "data-name": "88%",
    transform: "translate(367 2268)",
    fill: "#454545",
    fontSize: 10,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700,
    opacity: 0.994
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "88%")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ring Chart1",
    fill: "#fd0826"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 136",
    d: "M376.503 2243.227a21.5 21.5 0 0 1 18.618 10.749 21.5 21.5 0 0 1 0 21.5l-3.75-2.165a17.167 17.167 0 0 0 0-17.167 17.167 17.167 0 0 0-14.868-8.586Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 137",
    d: "M395.12 2275.474a21.5 21.5 0 0 1-27.945 8.62l1.879-3.9a17.167 17.167 0 0 0 22.316-6.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 138",
    d: "M367.175 2284.094a21.5 21.5 0 0 1-10.684-27.223l4.031 1.582a17.167 17.167 0 0 0 8.532 21.739Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 139",
    d: "M356.486 2256.871a21.5 21.5 0 0 1 20.016-13.644v4.331a17.167 17.167 0 0 0-15.981 10.9Z",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 33",
    width: 122,
    height: 4,
    rx: 1,
    transform: "translate(408 2262)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 34",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(408 2269)",
    fill: "#9098a4",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1223",
    transform: "translate(0 -6)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1507",
    width: 172,
    height: 4,
    rx: 1,
    transform: "translate(358 2314)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1509",
    width: 172,
    height: 4,
    rx: 1,
    transform: "translate(358 2323)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1510",
    width: 172,
    height: 4,
    rx: 1,
    transform: "translate(358 2332)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1508",
    width: 77,
    height: 4,
    rx: 1,
    transform: "translate(358 2305)",
    opacity: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgProfiler);
export default __webpack_public_path__ + "static/media/esg-profiler.902c06169227709060c02aeff3f84b8e.svg";
export { ForwardRef as ReactComponent };